import { ContentCard } from "@/components/contentCard";

export const FEATURES_CONSTANTS = {
  title: "What Makes Our Platform Modern?",
  desc: "As threats grow more sophisticated, OneMind stays ahead by integrating the latest frameworks and intelligence into every layer of protection.",
  list: [
    {
      title: "Mapped to MITRE. Driven by Intelligence. ",
      content: (
        <ContentCard
          text="OneMind integrates real-time threat intel feeds to detect global attack patterns and emerging malware campaigns. All threats are mapped to the MITRE ATT&CK framework, giving your team better context, faster response, and smarter prioritization. "
          points={[
            "Global IOC correlation",
            "MITRE-aligned TTP tracking",
            "Context-rich alerts",
          ]}
        />
      ),
    },
    {
      title: "Continuous Visibility into Your Attack Surface",
      content: (
        <ContentCard
          text="From misconfigured cloud assets to unmanaged endpoints, OneMind continuously scans and assesses your external attack surface. Gain visibility into vulnerabilities, third-party exposure, and shadow IT — before they become entry points. "
          points={["Asset discovery", "Risk scoring", "Shadow IT detection"]}
        />
      ),
    },
    {
      title: "Test, Train, and Stay Ready",
      content: (
        <ContentCard
          text="OneMind enables safe threat simulation to test response times and team readiness. Run tabletop exercises, simulate ransomware incidents, and validate your defense stack against real-world attack chains. "
          points={["Attack emulation", "Response validation", "Staff awareness training"]}
        />
      ),
    },
    {
      title: "Human-Backed Intelligence",
      content: (
        <ContentCard
          text="Automate containment, user lockdown, and alert triage using OneMind’s built-in workflows. Let AI handle the noise, while your team focuses on strategic threats. "
          points={["Auto-isolation", "MTTR reduction", "Analyst-assisted decision"]}
        />
      ),
    },
  ],
};
